<template>
  <div class="company-info">
    <MoreTitle title="公司资料" @click="goPage" />
    <div class="row-wrapper edge-padding">
      <RowInfo label="公司名称" value-class="ml-20px">{{ $digitjs(name).isNull() }}</RowInfo>
      <RowInfo label="上市日期" value-class="ml-20px">{{ $digitjs(companyData.listDate).isNull() }}</RowInfo>
      <RowInfo label="董事长" value-class="ml-20px">{{ $digitjs(companyData.chairman).isNull() }}</RowInfo>
      <RowInfo label="办公地址" value-class="ml-20px">{{ $digitjs(companyData.comAddress).isNull() }}</RowInfo>
      <RowInfo v-if="market !== 'hs'" label="员工数量" value-class="ml-20px">{{
        $digitjs(companyData.numberOfEmployees).isNull()
      }}</RowInfo>
      <RowInfo label="公司官网" value-class="ml-20px">{{ $digitjs(companyData.website).isNull() }}</RowInfo>
      <RowInfo label="主营业务" value-class="ml-20px">{{ companyData.comBusiness }}</RowInfo>
    </div>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
export default {
  components: { RowInfo },
  data() {
    return {
      companyData: {}
    }
  },
  computed: {
    lang() {
      return this.$i18n.lang
    },
    name() {
      const nameMap = {
        'zh-cn': this.companyData?.name ?? this.companyData?.cnName ?? this.companyData?.cnComName,
        'zh-hk': this.companyData?.name ?? this.companyData?.cnName ?? this.companyData?.cnComName,
        'en-us':
          this.companyData?.name ??
          this.companyData?.enName ??
          this.companyData?.enComName ??
          this.companyData?.cnName ??
          this.companyData?.cnComName
      }
      return nameMap[this.lang] ?? nameMap['zh-cn']
    },
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  created() {
    this.getCompanyInfo()
  },
  methods: {
    async getCompanyInfo() {
      const res = await this.$post(this.$api.f10[this.market] + '/summary/com-info', {
        symbol: this.symbol
      })
      this.companyData = res.data[0] ?? {}
    },
    goPage() {
      this.$router.push({
        path: '/f10/company',
        query: {
          symbol: this.symbol
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.company-info {
  font-size: 15px;
  background: var(--bg-color-2);
  .info-item {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    .name {
      flex-shrink: 0;
      width: 70px;
    }
    .value {
      text-align: right;
      word-break: break-all;
    }
  }
  .info-item-2 {
    .name {
      padding: 4px 0;
    }
  }
  .name {
    color: var(--font-color-3);
  }
}
</style>
